import { request } from './requests';
import { response } from './responses';
import { AuthSingleton, type Singleton } from './common';
import { jwt } from './jwt';

export const interceptors = { request, response };
export { AuthSingleton, jwt, type Singleton };
export type { RequestInterceptorOptions } from './requests';
export type { ResponseInterceptorOptions } from './responses';
